import { Portal } from '@chakra-ui/react';

import { CloseButton } from '../CloseButton';
import { DialogOrDrawer } from '../DialogOrDrawer';

interface SwapDialogProps {
  isOpen: boolean;
  close: () => void;
  closable: boolean;
  children: React.ReactNode;
  hidden?: boolean;
}

export const SwapDialog = ({
  isOpen,
  close,
  closable,
  children,
}: SwapDialogProps) => {
  return (
    <DialogOrDrawer.Root
      size={{
        desktopDown: 'full',
        desktop: 'md',
      }}
      placement={{
        desktopDown: 'bottom',
        desktop: 'top',
      }}
      scrollBehavior="inside"
      closeOnInteractOutside={false}
      open={isOpen}
      onOpenChange={(state) => !state.open && close()}
    >
      <DialogOrDrawer.Backdrop />
      <Portal>
        <DialogOrDrawer.Positioner>
          <DialogOrDrawer.DragContent
            data-disabled={!closable}
            minH={{
              desktop: 'min(700px, 80dvh)',
            }}
          >
            <DialogOrDrawer.CloseTrigger hidden={!closable} asChild>
              <CloseButton />
            </DialogOrDrawer.CloseTrigger>
            <DialogOrDrawer.Header>
              <DialogOrDrawer.Title>Buy / Sell</DialogOrDrawer.Title>
            </DialogOrDrawer.Header>
            {children}
          </DialogOrDrawer.DragContent>
        </DialogOrDrawer.Positioner>
      </Portal>
    </DialogOrDrawer.Root>
  );
};
